import { AccessRefreshToken, FormDataKeyValuePair, OAuthIntegration } from '@glueapp/graph-types';

export const googleAuthorizeUrl = 'https://accounts.google.com/o/oauth2/v2/auth';
export const googleAccessTokenUrl = 'https://oauth2.googleapis.com/token';

export const GoogleBaseIntegration: Pick<
    OAuthIntegration<AccessRefreshToken, { GOOGLE_CLIENT_ID: string; GOOGLE_CLIENT_SECRET: string }, {}>,
    'getGrantTypeTokenFormData' | 'getRefreshTokenFormData' | 'getAccessTokenUrl' | 'resolveTokenAndMetaDataFromSuccessResponse'
> = {
    getAccessTokenUrl(): string {
        return googleAccessTokenUrl;
    },
    getGrantTypeTokenFormData(
        queryParams: { [p: string]: string },
        redirectUri: string,
        secrets: { GOOGLE_CLIENT_ID: string; GOOGLE_CLIENT_SECRET: string },
    ): FormDataKeyValuePair[] {
        return [
            { key: 'client_id', value: secrets.GOOGLE_CLIENT_ID },
            { key: 'client_secret', value: secrets.GOOGLE_CLIENT_SECRET },
            { key: 'code', value: queryParams.code },
            { key: 'grant_type', value: 'authorization_code' },
            { key: 'redirect_uri', value: redirectUri },
        ];
    },
    getRefreshTokenFormData(refreshToken, secrets): FormDataKeyValuePair[] {
        return [
            { key: 'client_id', value: secrets.GOOGLE_CLIENT_ID },
            { key: 'client_secret', value: secrets.GOOGLE_CLIENT_SECRET },
            { key: 'grant_type', value: 'refresh_token' },
            { key: 'refresh_token', value: refreshToken },
        ];
    },
    resolveTokenAndMetaDataFromSuccessResponse: responseData => {
        return {
            tokens: {
                access_token: responseData.access_token,
                refresh_token: responseData.refresh_token,
            },
            metaData: {},
        };
    },
};
